import React from "react";
import { TEACHER_HUB_SPOKES } from "../../landingContent";
import SectionHeading from "../SectionHeading";

const ClassroomExamplesSection = ({
  onScrollToHowItWorks,
  headline = TEACHER_HUB_SPOKES.headline,
  subheading = TEACHER_HUB_SPOKES.subheading,
  showCta = true,
  ctaLabel = TEACHER_HUB_SPOKES.optionalCta,
  sectionClassName = "",
}) => (
  <section
    className={`landing-v2__section landing-v2-teacher-hub-spokes${sectionClassName ? ` ${sectionClassName}` : ""}`}
    aria-labelledby="examples-heading"
  >
    <div className="landing-v2__container">
      <SectionHeading
        headline={headline}
        subheading={subheading}
        headingLevel={2}
        headingId="examples-heading"
      />

      <div className="landing-v2-teacher-hub-spokes__layout">
        <div className="landing-v2-teacher-hub-spokes__grid">
          {TEACHER_HUB_SPOKES.spokes.map(({ id, title, description, imageSrc, imageAlt }, index) => (
            <article
              key={id}
              className={`landing-v2-teacher-hub-spokes__card landing-v2-teacher-hub-spokes__card--${index + 1}`}
            >
              <div className="landing-v2-teacher-hub-spokes__screenshot-frame">
                <img src={imageSrc} alt={imageAlt} loading="lazy" />
              </div>
              <div className="landing-v2-teacher-hub-spokes__card-copy">
                <h3>{title}</h3>
                <p>{description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>

      {showCta && typeof onScrollToHowItWorks === "function" ? (
        <div className="landing-v2__cta-row landing-v2__cta-row--center landing-v2-teacher-hub-spokes__cta">
          <button
            type="button"
            className="landing-v2__btn landing-v2__btn--secondary"
            onClick={onScrollToHowItWorks}
          >
            {ctaLabel}
          </button>
        </div>
      ) : null}
    </div>
  </section>
);

export default ClassroomExamplesSection;
